import request from '@/utils/request'
export function getList() {
  return request({
    url: 'mt/teams',
    method: 'get',
  })
}
export function getListBycity(city) {
  return request({
    url: 'mt/team/'+city,
    method: 'get',
  })
}
export function updatePoint(id) {
    return request({
      url: '/mt/point/'+id,
      method: 'put'
    })
}


export function getMsgwall(city) {
  return request({
    url: '/msgwall/'+city,
    method: 'get',
  })
}



// WEBPACK FOOTER //
// ./src/api/team_api.js